import React from "react";

const TermsIcon = ({ fill = "#387CFF", stroke = "#387CFF", ...props }) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    {...props} // Spread additional props (e.g., className, style)
  >
    
    <path
      d="M6.74961 4.50002H14.9996M3.74961 4.50752L3.75711 4.49927M3.74961 9.00752L3.75711 8.99927M2.84961 13.35L3.44961 13.95L4.94961 12.45M6.74961 9.00002H14.9996M6.74961 13.5H14.9996"
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1"
    />
  </svg>
);

export default TermsIcon;
